import { Treinnummer } from "@/entities/opstartplan/index.ts";
import { Time, timeToDate } from "@/shared/utils";
import { z } from "zod";

export const treinserieFormSchema = z.object({
    nummer: z.string(),
    traject: z.object({
        vanStation: z.string().nonempty("Selecteer een station"),
        naarStation: z.string().nonempty("Selecteer een station"),
    }),
    vertrekDatumTijd: z.iso.time({
        precision: -1,
        error: (issue) => (issue.input === undefined ? "Vul de vertrektijd in" : "Vul een geldige tijd in"),
    }),
});

export type TreinserieFormData = z.infer<typeof treinserieFormSchema>;

export function mapFormDataToTrein(data: TreinserieFormData): Treinnummer {
    const vertrekDatumTijd = timeToDate(data.vertrekDatumTijd as Time);

    return {
        nummer: Number(data.nummer),
        traject: data.traject,
        vertrekDatumTijd,
    };
}
